import { createSelector } from '@ngrx/store';
import { IAppState } from '../../common/interfaces/app-state.interface';
import { ICustomerPortfolioStore } from '../interfaces/customer-portfolio-store.interface';

export const selectCustomerPortfolioStore = (state: IAppState) =>
  state.customerPortfolio;

export const selectClientCustomerId = createSelector(
  selectCustomerPortfolioStore,
  (customerPortfolioStore: ICustomerPortfolioStore) => ({
    clientCustomerId: customerPortfolioStore.clientCustomerId,
  })
);

export const federalDocumentNumber = createSelector(
  selectCustomerPortfolioStore,
  (customerPortfolioStore: ICustomerPortfolioStore) => ({
    federalDocumentNumber: customerPortfolioStore.federalDocumentNumber,
  })
);


export const selectCustomerName = createSelector(
  selectCustomerPortfolioStore,
  (customerPortfolioStore: ICustomerPortfolioStore) =>
    customerPortfolioStore.customerName
);

export const selectCustomerType = createSelector(
  selectCustomerPortfolioStore,
  (customerPortfolioStore: ICustomerPortfolioStore) => ({
    customerType: customerPortfolioStore.customerType,
  })
);

export const selectCustomerBillingAddress = createSelector(
  selectCustomerPortfolioStore,
  (customerPortfolioStore: ICustomerPortfolioStore) => ({
    customerBillingAddess: customerPortfolioStore,
  })
);

export const selectPhysicalAddress = createSelector(
  selectCustomerPortfolioStore,
  (customerPortfolioStore: ICustomerPortfolioStore) => ({
    physicalAddress: customerPortfolioStore.physicalAddress,
  })
);

export const selectInvoiceTerms = createSelector(
  selectCustomerPortfolioStore,
  (customerPortfolioStore: ICustomerPortfolioStore) => ({
    customerInvoiceTerm: customerPortfolioStore.invoiceTerm,
  })
);

export const selectCustomerSearch = createSelector(
  selectCustomerPortfolioStore,
  (customerPortfolioStore: ICustomerPortfolioStore) => ({
    customerSearch: customerPortfolioStore.customerSearch,
  })
);

export const selectCustomerDetails = createSelector(
  selectCustomerPortfolioStore,
  (customerPortfolioStore: ICustomerPortfolioStore | undefined) => ({
    clientCustomerId: customerPortfolioStore?.clientCustomerId ?? -1,
    clientId: customerPortfolioStore?.clientId ?? -1,
    CustomerRefNumber: customerPortfolioStore?.CustomerRefNumber ?? '',
    customerName: customerPortfolioStore?.customerName ?? '',
    isFederal: customerPortfolioStore?.isFederal ?? false,
    billingAddress: customerPortfolioStore?.billingAddress ?? null,
    headquarterAddress: customerPortfolioStore?.headquarterAddress ?? null,
    headquarterCountry: customerPortfolioStore?.headquarterCountry ?? '',
    isHeadquarterAddress: customerPortfolioStore?.isHeadquarterAddress ?? false,
    customerType: customerPortfolioStore?.customerType ?? '',
    monthlyInvoiceAmount: customerPortfolioStore?.monthlyInvoiceAmount ?? '',
    invoiceTerm: customerPortfolioStore?.invoiceTerm ?? { id: -1, value: '' },
    billingCountry: customerPortfolioStore?.billingCountry ?? '',
    physicalAddress: customerPortfolioStore?.physicalAddress ?? null,
    physicalCountry: customerPortfolioStore?.physicalCountry ?? '',
    federalDocumentNumber: customerPortfolioStore?.federalDocumentNumber ?? -1,
    
    buyerId: customerPortfolioStore?.buyerId ?? -1,
    buyerName: customerPortfolioStore?.buyerName ?? '',
    buyerAddress: customerPortfolioStore?.buyerAddress ?? '',
    buyerCity: customerPortfolioStore?.buyerCity ?? '',
    buyerPostcode: customerPortfolioStore?.buyerPostcode ?? '',
    buyerCountryCode: customerPortfolioStore?.buyerCountryCode ?? '',
    buyerRegion: customerPortfolioStore?.buyerRegion ?? '',
    buyerRegionCode: customerPortfolioStore?.buyerRegionCode ?? '',
  })
);
